import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as firebase from "firebase";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCTJS1UNTcfbRL1-_32G2wn2aqoVhxfLiM",
  authDomain: "cart-6d30b.firebaseapp.com",
  databaseURL: "https://cart-6d30b.firebaseio.com",
  projectId: "cart-6d30b",
  storageBucket: "cart-6d30b.appspot.com",
  messagingSenderId: "688814826710",
  appId: "1:688814826710:web:452bddde2175c48446d577"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

ReactDOM.render(<App />, document.getElementById("root"));
